/* eslint-disable no-underscore-dangle */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const getHourColor = (hour) => {
  if (hour < 6) return '#7c3aed';
  if (hour < 12) return '#f59e0b';
  if (hour < 18) return '#3b82f6';
  return '#f97316';
};

const LEGEND = [
  { label: '새벽 (0~5시)', color: '#7c3aed' },
  { label: '오전 (6~11시)', color: '#f59e0b' },
  { label: '오후 (12~17시)', color: '#3b82f6' },
  { label: '저녁 (18~23시)', color: '#f97316' },
];

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const { hour, count } = payload[0].payload;
  return (
    <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', fontSize: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
      <p style={{ fontWeight: 'bold', margin: 0 }}>{hour}시</p>
      <p style={{ margin: 0 }}>{count}회</p>
    </div>
  );
};

const PiCareBarChartHourly = () => {
  const { hourlyStat, loading } = useSelector((state) => state.picareDashboard);

  const data = useMemo(() => {
    const map = new Map(hourlyStat.map((item) => [item._id, item.count]));
    return Array.from({ length: 24 }, (_, h) => ({ hour: h, count: map.get(h) ?? 0 }));
  }, [hourlyStat]);

  if (loading.hourlyStat) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', padding: '0 8px' }}>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
        {LEGEND.map(({ label, color }) => (
          <span key={label} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: '#64748b' }}>
            <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: 2, background: color }} />
            {label}
          </span>
        ))}
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 8, left: -16, bottom: 0 }}>
            <XAxis dataKey="hour" tick={{ fontSize: 11 }} tickFormatter={(h) => `${h}시`} interval={5} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(0,0,0,0.04)' }} />
            <Bar dataKey="count" radius={[3, 3, 0, 0]}>
              {data.map((entry) => (
                <Cell key={entry.hour} fill={getHourColor(entry.hour)} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PiCareBarChartHourly;
